import { TenantProfileWorkStation } from '@models';

// action strings
export const ADD_WORK_STATION = 'ADD_WORK_STATION';
export const REMOVE_WORK_STATION = 'REMOVE_WORK_STATION';
export const CHANGE_WORK_STATION = 'CHANGE_WORK_STATION';
export const CLEAR_WORK_STATION = 'CLEAR_WORK_STATION';

export interface AddWorkStation {
  type: typeof ADD_WORK_STATION;
}

export interface RemoveWorkStation {
  type: typeof REMOVE_WORK_STATION;
  index: number;
}

export interface ChangeWorkStation {
  type: typeof CHANGE_WORK_STATION;
  workStation: TenantProfileWorkStation;
  index: number;
}

export interface ClearWorkStation {
  type: typeof CLEAR_WORK_STATION;
}

export type WorkStationActions =
  | AddWorkStation
  | RemoveWorkStation
  | ClearWorkStation
  | ChangeWorkStation;
